<template>
    <div>
        <Dwtable :classes="classes" 
                :data="value"
                :columns="columns" 
                stripe 
                border 
                :show-header="showHeader"
                :width="width"
                :height="height"
                :loading="loading"
                :disabled-hover="disabledHover"
                :highlight-row="highlightRow"
                :row-class-name="rowClassName"
                :size="size"
                :no-data-text="noDataText"
                :no-filtered-data-text="noFilteredDataText"
                @on-current-change="onCurrentChange"
                @on-select="onSelect"
                @on-select-cancel="onSelectCancel"
                @on-select-all="onSelectAll"
                @on-selection-change="onSelectionChange"
                @on-sort-change="onSortChange"
                @on-filter-change="onFilterChange"
                @on-row-click="onRowClick"
                @on-row-dblclick="onRowDblclick"
                @on-expand="onExpand"></Dwtable>
        <pages :url="url" @ievent="updateTable" @editSearch="search" from="editTable" :searchData.sync="searchData"></pages>
    </div>
</template>
<script>
const editButton = (vm, h, currentRow, index, item, child_item, params) => {
  return h('Button', {
    props:{
        disabled: !currentRow.editting&&eval(child_item.disabled)
    },
    attrs: {
      type: 'primary',
      size: 'small'
      // loading: currentRow.saving
    },
    style: {
      margin: '0 5px',
      display: child_item.show?'inline-block':'none'
    },
    on: {
      'click': () => {
        if (!currentRow.editting) {
            // 单条进行编辑
            let flag = true;
            vm.thisTableData.forEach(item => {
                if(item.editting) {
                    if(flag == false) return;
                    flag = false;
                    return;
                }
            })
            if (flag) {
                if (currentRow.edittingCell) {
                    for (const name in currentRow.edittingCell) {
                    currentRow.edittingCell[name] = false
                    vm.edittingStore[index].edittingCell[name] = false
                    }
                }
                vm.edittingStore[index].editting = true
                vm.thisTableData = JSON.parse(JSON.stringify(vm.edittingStore))
                vm.$emit('input', vm.thisTableData);
            } else {
                vm.$Message.destroy();
                vm.$Message.error('请先进行保存再编辑！');
            }
        } else {
            let flag;
                // console.log(vm.columns);
                // console.log(vm.handleBackdata(vm.edittingStore)[index]);
            vm.columns.forEach(item => {
                if(flag==false) return;
                if(item.editRule){
                    flag = vm.editRule(vm, item, params, index);
                    // let key = item.key;
                    // flag = vm.editRule(1,vm.edittingStore[index][key],vm.messageTip);
                } else {
                    flag = true;
                }
            })
            if (flag) {
                vm.edittingStore[index].saving = true
                vm.thisTableData = JSON.parse(JSON.stringify(vm.edittingStore))
                const edittingRow = vm.edittingStore[index]
                let editData = vm.handleBackdata(vm.thisTableData)[index];
                // // 提交数据
                let getSave = () => {
                    vm.thisTableData.forEach(item => {
                        item.editting = false;
                    })
                }
                if (editData.id) {
                    vm.$emit('editsubmit', vm.handleBackdata(vm.edittingStore), index, getSave);
                //     url = child_item.editUrl;
                } else {
                    vm.$emit('submit', vm.handleBackdata(vm.edittingStore), index, getSave)
                //     url = child_item.addUrl;
                }
                // vm.request(url, editData, true ).then(res => {
                    // edittingRow.editting = false;
                    // edittingRow.saving = false;
                //     vm.$emit('getTableValue', vm.handleBackdata(vm.thisTableData), index);
                //     vm.$emit('change', vm.handleBackdata(vm.thisTableData), index);
                //     vm.getData();
                //     vm.$Message.success('保存成功！');
                // });
                // console.log(vm.handleBackdata(vm.edittingStore), index);
            }
        }
      }
    }
  }, currentRow.editting ? '保存' : '编辑')
}
const cancelButton = (vm, h, currentRow, index) => {
  return h('Button', {
    props: {
      type: 'ghost',
      size: 'small'
    },
    style: {
      margin: '0 5px'
    },
    on: {
      'click': () => {
            const edittingRow = vm.edittingStore[index]
            if (!currentRow.indexsequence) {
                vm.cloneTableData.shift();
                vm.thisTableData = JSON.parse(JSON.stringify(vm.cloneTableData))
                vm.edittingStore = JSON.parse(JSON.stringify(vm.cloneTableData))
                // 更新表格数据
                vm.$emit('input', vm.handleBackdata(vm.thisTableData))
            } else {
                vm.cloneTableData[index].editting = false;
                vm.thisTableData = JSON.parse(JSON.stringify(vm.cloneTableData))
                // 更新表格数据
                vm.$emit('input', vm.handleBackdata(vm.thisTableData))
            }
        }
    }
  }, '取消')
}
const deleteButton = (vm, h, currentRow, index, param, child_item) => {
    let params = param;
    return h('Button', {
        props: {
            disabled: eval(child_item.disabled)
        },
        attrs: {
        type: 'error',
        size: 'small'
        // loading: currentRow.saving
        },
        style: {
        margin: '0 5px'
        },
        on: {
            'click': () => {
                let key;
                params.column.handle.forEach(item => {
                    if (item.type == 'delete') {
                        key = item.deleteKey
                    }
                });
                // 判断是否处于编辑状态
                let flag = true;
                let num;
                vm.thisTableData.forEach((item, _index) => {
                    if(item.editting) {
                        if(flag == false) return;
                        flag = false;
                        num = _index;
                        return;
                    }
                })
                if (flag) {
                    // 要传的参数
                    vm.$Modal.confirm({
                        title: "提示",
                        content: "<p>是否删除</p>",
                        onOk: () => {
                            vm.$emit('deleteItem',currentRow[key]);
                        }
                    });
                } else {
                    if(index != num) {
                        vm.$Message.destroy();
                        vm.$Message.error('请先进行保存再删除！');
                    }
                }
            }
        }
    }, '删除')
}
const editInput = (vm, h, param, item) => {
  return h('Input', {
    props: {
      type: param.column.inputType?param.column.inputType:'text',
      value: param.row[item.key],
      placeholder: '请输入'
    },
    on: {
      'on-change'(event) {
        const key = param.column.key
        vm.edittingStore[param.index][key] = event.target.value.replace(/\s+/g,"");
      }
    }
  })
}
const editInputNumber = (vm, h, param, item) => {
    let newprops = {
        value: Number(param.row[item.key]),
        placeholder: '请输入',
    };
    if (param.column.props) {
        if (param.column.props.min) {
            newprops['max'] = param.column.props.max;
        }
        if (param.column.props.min) {
            newprops['min'] = param.column.props.min;
        }
    }
    return h('InputNumber', {
        props: newprops,
        on: {
            'on-change'(val) {
                const key = param.column.key
                vm.edittingStore[param.index][key] = val;
            }
        }
    })
}
// const selected = (vm, h, param, item, Arr) => {
//     console.log(Arr)
//     return h('Select', {
//         props: {
//             value: param.row[item.key]?param.row[item.key].toString():'1',
//             placeholder:'请选择',
//             filterable: true
//         },
//         on: {
//             'on-change'(event) {
//                 const key = param.column.key
//                 param.row[item.key] = event
//                 vm.edittingStore[param.index][key] = event
//                 // console.log(param.row[item.key])
//                 // console.log(param.row,555,item.key,key, event)
//             }
//         }
//     }, Arr)
// }
const editSelect = (vm, h, param, item, currentRow) => {
    // vm.$emit('editEvent');
    const Arr = [];
    let selects = [];
    if (param.column.selectArr) {
        selects = param.column.selectArr;
    } else {
        selects = vm.selectArr[item.key];
    }
    if(param.column.getEvent){
        vm.$emit(param.column.getEvent.event, param.row[item.key], param.column.getEvent.key);
    }
    let flag = 0;
    let selectRender = h('test-rool', {
                props: {
                    value: vm.edittingStore[param.index][item.key]?vm.edittingStore[param.index][item.key].toString():'1',
                    placeholder:'请选择',
                    filterable: true,
                    Arrs: selects
                },
                on: {
                    'on-change'(event) {
                        const key = param.column.key;
                        // vm.edittingStore[param.index][key] = event;
                        // console.log(param.column.getEvent)
                        flag = 1;
                        if(param.column.getEvent){
                            vm.$emit(param.column.getEvent.event, event.value, param.column.getEvent.key);
                            // vm.edittingStore[param.index][param.column.getEvent.key] = '';
                            vm.edittingStore[param.index][key] = event.value;
                            vm.edittingStore[param.index][key+'Label'] = event.label;
                            vm.$set(vm.edittingStore[param.index], param.column.getEvent.key, '');
                        } else {
                            vm.edittingStore[param.index][key] = event.value;
                            vm.edittingStore[param.index][key+'Label'] = event.label;
                        }
                    }
                }
            });
    if(param.column.show) {
        if(eval(param.column.show)){
            return selectRender;
        } else {
            return h('span', {}, '-');
        }
    } else {
        return selectRender;
    }
    
}
const clickShow = (vm, h, param, text, item) => {
    return h('div',{
            attrs:{'class':param.column.key+'-render'},
            style: {
                color: '#81a7da',
                cursor: 'pointer'
            },
            on: {
                'click': () => {
                    vm.edittingStore.forEach(item => {
                        item.clickShow = false;
                    });
                    vm.request(item.clickShow.url,{},true,param.row.id+(item.clickShow.url2?item.clickShow.url2:'')).then(res => {
                        vm.edittingStore[param.index].clickText = res.content.data.secret_key;
                        vm.edittingStore[param.index].clickShow = true;
                        vm.thisTableData = JSON.parse(JSON.stringify(vm.edittingStore))
                    })
                }
            }
        },text
    )
}
const clickShowText = (vm, h, currentRow, param) => {
    return h('div', {
        style: {
            color: '#81a7da',
            cursor: 'pointer'
        },
        on: {
            'click': () => {
                vm.edittingStore[param.index].clickShow = false;
                vm.thisTableData = JSON.parse(JSON.stringify(vm.edittingStore))
            }
        }
    }, currentRow.clickText)
}
import pages from '../pages.vue';
export default {
    data() {
        return {
            thisTableData: [],
            cloneTableData: [],
            flag: 0
        }
    },
    watch: {
        value(data) {
            this.init();
        }
    },
    props: {
        columns: {
            type: Array
        },
        classes: {
            type: String
        },
        data: {
            type: Array
        },
        value: Array,
        url: String,
        searchData: {
            type: Object
        },
        stripe: Boolean,
        border: Boolean,
        showHeader: {
            type: Boolean,
            default: true
        },
        width: {
            type: [Number, String]
        },
        height: {
            type: [Number, String]
        },
        loading: Boolean,
        disabledHover: {
            type: Boolean,
            default: false
        },
        highlightRow: {
            type: Boolean,
            default: false
        },
        rowClassName: {
            type: Function
        },
        size: String,
        noDataText: String,
        noFilteredDataText: String,
        selectArr: Object
    },
    components: {
        pages
    },
    methods: {
        onCurrentChange(currentRow, oldCurrentRow) {
            this.$emit('on-current-change', currentRow, oldCurrentRow);
        },
        onSelect(selection, row) {
            this.$emit('on-select', selection, row);
        },
        onSelectCancel(selection, row) {
            this.$emit('on-select-cancel', selection, row);
        },
        onSelectAll(selection) {
            this.$emit('on-select-all', selection);
        },
        onSelectionChange(selection) {
            this.$emit('on-selection-change', selection)
        },
        onSortChange(selection) {
            this.$emit('on-sort-change', selection)
        },
        onFilterChange(val) {
            this.$emit('on-filter-change', val)
        },
        onRowClick(val, index) {
            this.$emit('on-row-click', val, index);
        },
        // 双击表格行
        onRowDblclick(val, index) {
            this.$emit('on-row-dblclick', val, index);
            // 单条进行编辑
            let flag = true;
            let num;
            this.thisTableData.forEach((item, _index) => {
                if(item.editting) {
                    if(flag == false) return;
                    flag = false;
                    num = _index;
                    return;
                }
            })
            if (flag) {
                if(!this.edittingStore[index].editdisabled&&this.edittingStore[index].show){
                    this.edittingStore[index].editting = true;
                    this.thisTableData = JSON.parse(JSON.stringify(this.edittingStore));
                    this.$emit('input', this.thisTableData);
                } else {
                    this.$Message.destroy();
                    this.$Message.error('该条记录不可编辑');
                }
            } else {
                // 判断双击的是不是正在编辑的行
                if(index != num) {
                    this.$Message.destroy();
                    this.$Message.error('请先进行保存再编辑！');
                }
            }
        },
        onExpand(row, status) {
            this.$emit('on-expand', row, status);
        },
        init() {
            const vm = this
            const editableCell = this.columns.filter(item => {
                if (item.editable) {
                if (item.editable === true) {
                    return item
                }
                }
            })
            let cloneData;
            if(this.value) {
                cloneData = JSON.parse(JSON.stringify(this.value))
            } else {
                cloneData = [];
            }
            let res = []
            res = cloneData.map((item, index) => {
                let isEditting = false
                if (this.thisTableData[index]) {
                if (this.thisTableData[index].editting) {
                    isEditting = true
                } else {
                    for (const cell in this.thisTableData[index].edittingCell) {
                    if (this.thisTableData[index].edittingCell[cell] === true) {
                        isEditting = true
                    }
                    }
                }
                }
                if (isEditting) {
                return this.thisTableData[index]
                } else {
                if (!item.editting) {
                    this.$set(item, 'editting', false)
                }
                const edittingCell = {}
                editableCell.forEach(item => {
                    edittingCell[item.key] = false
                })
                this.$set(item, 'edittingCell', edittingCell)
                return item
                }
            })
            this.thisTableData = res
            this.edittingStore = JSON.parse(JSON.stringify(this.thisTableData))
            this.cloneTableData = JSON.parse(JSON.stringify(this.thisTableData))
            this.columns.forEach((item, index) => {
                // 判断是否可编辑
                if (item.editable) {
                    // console.log(item.appendRender);
                    let appendNull = (h, params) => {return h('span')};
                    let appendRender = item.appendRender?item.appendRender:appendNull;
                    let userNotEditRender; 
                    item.render = (h, param) => {
                        const currentRow = this.thisTableData[param.index];
                        const params = {
                            row: param.row,
                            index: param.index
                        }
                        let overFlow = (h, params) => { return h('over-flow', {props:{text:currentRow[item.key]?currentRow[item.key].toString():''}})};
                        // 判断是否要溢出隐藏
                        if (!item.notOverFlow) {
                            userNotEditRender = item.userNotEditRender?item.userNotEditRender:overFlow;
                        } else {
                            userNotEditRender = item.userNotEditRender?item.userNotEditRender:appendNull;
                        }
                        // 不可编辑状态
                        if(!currentRow.editting){
                            return h('div',{attrs:{'class':item.key+'-render'}}, [userNotEditRender(h, params)]);
                        } else {  //可编辑状态
                            if (item.editType == 'select') {
                                return h('div',{attrs:{'class':item.key+'-append'}}, [editSelect(this, h, param, item, currentRow), appendRender(h, params)])
                            } else if (item.editType == 'input') {
                                return h('div',{attrs:{'class':item.key+'-append'}}, [editInput(this, h, param, item), appendRender(h, params)])
                            } else if (item.editType == 'editInputNumber') {
                                return h('div',{attrs:{'class':item.key+'-append'}}, [editInputNumber(this, h, param, item), appendRender(h, params)])
                            }
                        }
                    }
                } else {
                    let appendNull = (h, params) => {return h('span')};
                    let appendRender = item.appendRender?item.appendRender:appendNull;
                    let userNotEditRender; 
                    item.render = (h, param) => {
                        const currentRow = this.thisTableData[param.index];
                        const params = {
                            row: param.row,
                            index: param.index
                        }
                        let overFlow = (h, params) => { return h('over-flow', {props:{text:currentRow[item.key]?currentRow[item.key].toString():''}})};
                        // 判断是否要溢出隐藏
                        if (!item.notOverFlow) {
                            userNotEditRender = item.userNotEditRender?item.userNotEditRender:overFlow;
                        } else {
                            userNotEditRender = item.userNotEditRender?item.userNotEditRender:appendNull;
                        }
                        return h('div',{attrs:{'class':item.key+'-render'}}, [userNotEditRender(h, params)]);
                    }
                }
                if (item.clickShow) {
                    item.render = (h, param) => {
                        let text = item.clickShow.text;
                        const currentRow = this.thisTableData[param.index];
                        if (!currentRow.editting) {
                            if(!currentRow.clickShow){
                                return clickShow(vm, h, param, text, item)
                            } else {
                                return clickShowText(vm, h, currentRow, param);
                            }
                        }
                    }
                }
                // if (item.editable) {
                //     if (item.hasRender) {
                //         let oldRender;
                //         if(item.render){
                //             oldRender = item.render;
                //         }
                //         item.render = (h, param) => {
                //             const currentRow = this.thisTableData[param.index]
                //             const params = {
                //                 row: param.row,
                //                 index: param.index
                //             }
                //             if (!currentRow.editting) {
                //                 if (oldRender) {
                //                     return oldRender(h, params)
                //                 } else if (!item.notOverFlow) {
                //                     return h('over-flow', {props:{text:currentRow[item.key]?currentRow[item.key].toString():''}})
                //                 } else {
                //                     return h('span', currentRow[item.key])
                //                 }
                //             } else {
                //                 if (item.appendRender) {
                //                     let appendRender = item.appendRender;
                //                     if (item.editType == 'select') {
                //                         return h('div',{attrs:{'class':item.key+'-append'}}, [editSelect(this, h, param, item), appendRender(h, params)])
                //                     } else if (item.editType == 'input') {
                //                         return h('div',{attrs:{'class':item.key+'-append'}}, [editInput(this, h, param, item), appendRender(h, params)])
                //                     }
                //                 } else {
                //                     if (item.editType == 'select') {
                //                         return editSelect(this, h, param, item)
                //                     } else if (item.editType == 'input') {
                //                         return editInput(this, h, param, item)
                //                     }
                //                 }
                //             }
                //         }
                //     } else {
                //         item.render = (h, param) => {
                //             const currentRow = this.thisTableData[param.index]
                //             if (!currentRow.editting) {
                //                     if (!item.notOverFlow) {
                //                         return h('over-flow', {props:{text:currentRow[item.key]?currentRow[item.key].toString():''}})
                //                     } else {
                //                         return h('span', currentRow[item.key])
                //                     }
                //             } else {
                //                 return editInput(this, h, param, item)
                //             }
                //         }
                //     }
                // } else {
                //     if (item.hasRender) {
                //         let oldRender;
                //         if(item.render){
                //             oldRender = item.render;
                //         }
                //         item.render = (h, param) => {
                //             const params = {
                //                 row: param.row,
                //                 index: param.index
                //             }
                //             const currentRow = this.thisTableData[param.index];
                //             if (oldRender) {
                //                 return oldRender(h, params)
                //             } else if (!item.notOverFlow) {
                //                 return h('over-flow', {props:{text:currentRow[item.key]?currentRow[item.key].toString():''}})
                //             } else {
                //                 return h('span', currentRow[item.key])
                //             }
                //         }
                //     } else {
                //         item.render = (h, param) => {
                //             const currentRow = this.thisTableData[param.index]
                //             if (!item.notOverFlow) {
                //                 return h('over-flow', {props:{text:currentRow[item.key]?currentRow[item.key].toString():''}})
                //             } else {
                //                 return h('span', currentRow[item.key])
                //             }
                //         }
                //     }
                // }
                if (item.handle) {
                    item.render = (h, param) => {
                        const currentRowData = this.thisTableData[param.index];
                        const children = [];
                        let params = param;
                        item.handle.forEach(child_item => {
                            if (child_item.type === 'edit') {
                                this.edittingStore[param.index].editdisabled = eval(child_item.disabled);
                                this.edittingStore[param.index].show = eval(child_item.show);
                                // 判断是否要显示
                                if (this.edittingStore[param.index].show) {
                                    children.push(editButton(this, h, currentRowData, param.index, item, child_item, param))
                                }
                                if(currentRowData.editting){
                                    children.push(cancelButton(this, h, currentRowData, param.index, item, child_item))
                                }
                            } else if (child_item.type === 'delete') {
                                this.edittingStore[param.index].deltedisabled = eval(child_item.disabled);
                                this.edittingStore[param.index].show = eval(child_item.show);
                                if(!currentRowData.editting){
                                    // 判断是否要显示
                                    if (this.edittingStore[param.index].show) {
                                        children.push(deleteButton(this, h, currentRowData, param.index, param, child_item))
                                    }
                                }
                                // children.push(deleteButton(this, h, currentRowData, param.index, param))
                            }
                        })
                        if(item.appendRender){
                            children.push(item.appendRender(h, param));
                        }
                        return h('div', children)
                    }
                }
            })
        },
        handleBackdata(data) {
            const clonedData = JSON.parse(JSON.stringify(data))
            clonedData.forEach(item => {
                delete item.editting
                delete item.edittingCell
                delete item.saving
            })
            return clonedData
        },
        // 验证规则
        editRule(vm, item, params, index) {
            if (item.editRule.require) {
                if(item.editRule.beforeKey){
                    // 有前置条件时，如果有前置条件则判断是否为空，没有就不判断
                    if(vm.edittingStore[index][item.editRule.beforeKey]){
                        if(!vm.edittingStore[index][item.key]) {
                            if (item.editRule.ruleTip) {
                                this.$Message.error(item.editRule.ruleTip);
                            } else {
                                this.$Message.error('请输入' + item.title);
                            }
                            return false;
                        }
                    }
                }
            }
            if (item.editRule.rule) {
                let rule = new RegExp(item.editRule.rule);
                if(!rule.test(vm.edittingStore[index][item.key])) {
                    if(item.editRule.untitle){
                        this.$Message.error('请输入正确' + item.editRule.ruleTip);
                    }else{
                        this.$Message.error('请输入正确' + item.title + ',' + item.editRule.ruleTip);
                    }
                    return false;
                }
            }
        },
        updateTable(val) {
            // this.$emit('search', val);
        },
        search(pageNum) {
            this.$emit('search', pageNum);
        },
        // getData() {
        //     this.request('getCustomerList', this.searchData, true).then(res => {
        //         this.thisTableData = JSON.parse(JSON.stringify(res.content.data));
        //         this.searchData.allcount = res.content.meta.total;
        //         this.sequence(this.thisTableData);
        //         this.$emit('input', this.handleBackdata(this.thisTableData));
        //     })
        // },
        //判断功能点##########
        FPAuthority(code) {
            let funcs=JSON.parse(window.localStorage.getItem('funcs'));
            return funcs.includes(code);
        },
        //分页列表序号
        sequence(val) {
            var numtan = (this.searchData.pageNum - 1) * this.searchData.pageSize;
            for (var i = 0; i < val.length; i++) {
                val[i].indexsequence = numtan + 1 + i;
            }
        },
        parentData(index, key, value) {
            this.edittingStore[index][key] = value;
        }
    },
    created() {
        this.init();
    }
}
</script>

<style lang="less" scoped>

</style>



// WEBPACK FOOTER //
// src/views/main-components/table/editTable.vue